
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { PosterManager } from "../independent/poster/PosterManager";
import { SanSymbolData } from "../../engine/Symbol/SanSymbolData";
import { SplashController } from "../independent/splashScreen/SplashController";

import { PostCounter } from "../independent/poster/PostCounter";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { GameConfig } from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { TimelineMax, Power3, Power1, Power2, Back } from "gsap";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { ReelAnimationController } from "../independent/reelAnimator/ReelAnimationController";
import { ReelAnimationManager } from "../independent/reelAnimator/ReelAnimationManager";
import { SanEngineManager } from "../../engine/SanEngineManager";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { RevealerManager } from "../independent/revealer/RevealerManager";
import { SanSymState } from "../../engine/Symbol/SanSpriteSymbol";
import { JumpingWildCollector } from "../independent/collector/JumpingWildCollector";
import { ReelOverlay } from "../background/ReelOverlay";
import { SanBackground } from "../background/SanBackground";
import { WinCounter } from "../independent/countup/WinCounter";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { SlotState } from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/SlotStateHandler";

export class TestPresentation extends Presentation {

    // public isActive():boolean{ return true };

    private gfx:PIXI.Graphics;
    private nastyTl:TimelineMax;

    private loopTl:TimelineMax;

    private toPos:PIXI.Point = new PIXI.Point(0);

    private s:number = 0;

    initialization():void{
    }

    preStart():void{
        this.s = 0;
        EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
        
    }

    isActive():boolean{
        return false;
    }

    public getPresentation(){

        ReelAnimationManager.getReelArea(0).playPlusScatter(2);
        ReelAnimationManager.getReelArea(1).playPlusScatter(1);


        // this.pTimeline.add(WinCounter.normalCounter.maniacUpAnimation(0,150000,16));
        // this.pTimeline.add(() => WinCounter.normalCounter.bounceHit(10));
        // SanBackground.instance.changeBgManiacBlackness(1,1);
        // ReelAnimationManager.getReelArea(0).splitMult(true)

        
        // PostCounter.instance.setAmount(2);

        // ReelAnimationManager.getReelArea(1).playPlusScatter(1);
        
        // const postDurr:number = this.pTimeline.add(PostCounter.instance.play(2)).duration();
        // PosterManager.instance.playTotalWin(10000);
    
        // PosterManager.instance.setBlackScreenAlpha(0.7,0.4),
        // ReelOverlay.instance.changeAlpha(0, 0.4),
        // SanBackground.instance.changeBgBlackness(0,0.4)
        // SplashController.instance.play(3).duration();

        // SplashController.instance.play(2);
        // PostCounter.instance.showDude(true);
        
        // if(this.s == 0 ){
        //     this.pTimeline.add(JumpingWildCollector.instance.setActiveJumpingWilds(0,1,2));
        //     this.pTimeline.add(JumpingWildCollector.instance.setActiveJumpingWilds(1,4,1),0);
        //     this.pTimeline.add(JumpingWildCollector.instance.setActiveJumpingWilds(2,0,0),0);
        // }
        // else{
        //     this.pTimeline.add(JumpingWildCollector.instance.popJumpingWilds());
        // }


        // this.pTimeline.add(() => RevealerManager.shuffleAll());
        // ReelAnimationManager.getReelArea(1).playLand();
        // this.pTimeline.add(() => RevealerManager.getAllBars().forEach(r => {if(r.isActive) r.shuffle(true) }));
        // SplashController.instance.setResultSplash( { fs:11, jw: 4 } )
        // SplashController.instance.play(1);
        // PosterManager.instance.setBlackScreenAlpha(0.7)
        // // let totDurr:number = 0;
        // let delay: number = PostCounter.instance.playShow().duration();
        // PostCounter.instance.setAmount(0);
        // this.pTimeline.to(this,delay,{});

        // JumpingWildCollector.instance.upgradeJW(2,1);

        // PostCounter.instance.test("Wild_X4");
        // this.pTimeline.add(() => PostCounter.instance.Stroker(3),delay);
        // this.pTimeline.add(() => PostCounter.instance.Stroker(3),"+=" + PostCounter.instance.strokeDrawDurr(3));
        // this.pTimeline.add(() => PostCounter.instance.Stroker(3),"+=" + PostCounter.instance.strokeDrawDurr(3));
        // this.pTimeline.add(() => PostCounter.instance.Stroker(3),"+=" + PostCounter.instance.strokeDrawDurr(3));
        // this.pTimeline.add(() => PostCounter.instance.Stroker(3),"+="+ PostCounter.instance.strokeDrawDurr(3));
        // this.pTimeline.add(() => PostCounter.instance.Stroker(3),"+="+ PostCounter.instance.strokeDrawDurr(3));
        // this.pTimeline.add(() => PostCounter.instance.Stroker(3),"+="+ PostCounter.instance.strokeDrawDurr(3));
        // this.pTimeline.add(() => PostCounter.instance.Stroker(3),"+="+ PostCounter.instance.strokeDrawDurr(3));
        // this.pTimeline.add(() => PostCounter.instance.Stroker(3),"+="+ PostCounter.instance.strokeDrawDurr(3));
        // this.pTimeline.to(this,1,{})

        // this.pTimeline.add(() => PostCounter.instance.playEnd2(), "+=" + 0.75);

        this.PresentationState.set(PresentationState.END);
        // this.pTimeline.to(this,1.2,{});
        // SlotGame.keypad.
        // SlotGame.keypad.events.trigger(SlotState.SKIPPED);
        // EventHandler.dispatchEvent(new GameEvent(SpinEvent.SKIP));
        // this.pTimeline.to(this,totDurr,{},0);
        // this.pTimeline.add(RevealerManager.getTopBar(3).playSpine(2));
        // EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));

        // this.pTimeline.add(() => this.gfx.visible = true);
        // this.movement();

        // this.pTimeline.to(this,1000000,{});

        // this.pTimeline.add(() => this.gfx.visible = false);

        // this.pTimeline.add(RevealerManager.FullRevealer(0).reveal());

        // console.log(PIXI.utils.TextureCache)
        // this.pTimeline.add( SplashController.instance.play());
        // PosterManager.instance.setBlackScreenAlpha(0.4)

        // if(JumpingWildController.instance.items.length == 0)
        //     JumpingWildController.instance.createJumpWilds(2,0);

        // this.pTimeline.add(JumpingWildController.instance.JumpTo(
        //     {ID:0,
        //     state:"",
        //     duration:0.5, 
        //     to:{reel: Math.floor(Math.random() * 3),row:Math.floor(Math.random() * 2)}}
        // ))

        // this.pTimeline.add(() => JumpingWildController.instance.MergeWithReel(0 ,true))
        // this.pTimeline.add(SplashController.instance.play(1));
        // PosterManager.instance.setBlackScreenAlpha(0.4);

        // this.pTimeline.add(this._pTest.play(-1));
        // this.PresentationState.set(PresentationState.END);
        // XWaysCounter.instance.setValue(undefined,900,1);
        // this.pTimeline.to(this,1,{});

        // this.pTimeline.add(SanEngineManager.getReel(0).getSymbol(1)?.changeState({
        //     state: ReelSymbolStates.CHANGE_SYMBOL,
        //     newSym:"W_J",
        //     duration: 0.4
        // }));
        // EventHandler.dispatchEvent(new GameEvent(SpinEvent.DONE));
        // this.pTimeline.add(() => EventHandler.dispatchEvent(new GameEvent(SpinEvent.DONE)));
        // this.pTimeline.to(this,1,{});

        // if(this.s == 1)
             
        // this.s++;
    }

    private movement():void{
        this.loopTl = Helper.timeLineKiller(this.loopTl,new TimelineMax({
            repeat:-1,
            repeatDelay:0,
        }));
        this.loopTl.add(() => this.createNewPath());
        this.loopTl.add(() => this.playPath())
        this.loopTl.to(this,1,{});
    }

    private createNewPath():void{
        const offsetVal:PIXI.Point = new PIXI.Point(200*Math.random(),20*Math.random());
        this.toPos = MathHelper.pointAdd(new PIXI.Point(360,360),
         new PIXI.Point( 
            offsetVal.x *(Math.random() > 0.5 ? 1: -1),
            offsetVal.y *(Math.random() > 0.5 ? 1: -1)
        ));
    }

    private playPath():TimelineMax {
        this.nastyTl = Helper.timeLineKiller(this.nastyTl,new TimelineMax());
        this.nastyTl.delay(0.2);
        this.nastyTl.to(this.gfx.position,0.5,{x:this.toPos.x,y:this.toPos.y,ease:Back.easeInOut});
        return this.nastyTl;
    }

    private createGraphic():PIXI.Graphics{
        const graphicBg:PIXI.Graphics =  new PIXI.Graphics();
        graphicBg.beginFill(0xFFFFFF, 1);
        graphicBg.drawRect(-SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH/2, -SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT/2,
             SanSymbolData.DEFAULT_SYMBOL.DIM.WIDTH, SanSymbolData.DEFAULT_SYMBOL.DIM.HEIGHT);
        graphicBg.endFill();
        // graphicBg.alpha = 0.5;
        return graphicBg;
    }

    public endPresentation(){

        // PosterManager.instance.stopTotalWin();
        // SanBackground.instance.stopCheering();
        // SanBackground.instance.restoreOverlay(3);

        // SplashController.instance.stop();

        // PostCounter.instance.showDude(false);
        // PostCounter.instance.removeStrokers();
        // SplashController.instance.stop();
        // // ReelAnimationManager.getReelArea(0).flashHotSymbol(false);

        // // XWaysCounter.instance.setValue(undefined,243,1);
        ReelAnimationManager.getReelArea(0).playPlusScatter(2);
        ReelAnimationManager.getReelArea(1).playPlusScatter(1);
        // // this.pTimeline.add(() => JumpingWildController.instance.MergeWithReel(0,false));
        // SplashController.instance.stop();
        // PosterManager.instance.setBlackScreenAlpha(0)
        this.PresentationState.set(PresentationState.INACTIVE);
    }

    public stopPresentation(){
        // PostCounter.instance.playResultFS();
        // SplashController.instance.stop();
        // PosterManager.instance.setBlackScreenAlpha(0);
        // PostCounter.instance.removeStrokers();
    }

    onResize():void{
        if(this.pTimeline && this.pTimeline.isActive()) this.pTimeline.totalProgress(1);
    }

    public skipPresentation(){
        
        this.PresentationState.set(PresentationState.INACTIVE);
        Helper.timeLineKiller(this.loopTl);
        this.pTimeline.totalProgress(1);
        // SplashController.instance.stop();
    }
}